module.exports = __webpack_public_path__ + "static/media/communications-icon.f447c19c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/communications-icon.svg
// module id = 1919
// module chunks = 0